// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5889) return "static/chunks/5889-a5b45a9f8d037da2.js";
	if (chunkId === 1557) return "static/chunks/1557-79c8cd90fcef7667.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6922 ? "47984944" : chunkId) + "." + {"2537":"eeb92dc401fb520d","2656":"c9315c7a07d6dc8d","3084":"fc96bf1f8dd8fa9a","5913":"fe29e89fc625907c","5921":"abb75dcfedc0a952","6922":"e6187cfb432c7b86","7037":"9b1eb1492c84a2fa","7115":"31c3e04ef72735a2","8639":"2c4ff6324d33c508"}[chunkId] + ".js";
};